<!--<app-banner *ngIf="bannerShow"></app-banner>-->
<router-outlet></router-outlet>
<cookie-law></cookie-law>
